import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "../atoms/AtomsViewer"
import './MarkdownQuote.less'

interface MarkdownQuoteProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownQuote: FC<MarkdownQuoteProps> = ({
                                                          block,
                                                          onToggleCheckBox
                                                      }) => {
    return (
        <div className="block quote">
            {block.atoms.map((atom, index) => (
                <div key={atom.id} className='quoteLine'><AtomsViewer atoms={atom.subAtoms} onToggleCheckBox={onToggleCheckBox}/></div>
            ))}
        </div>
    )
}
